import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { Tabs, Tab } from '@mui/material'
import { theme } from '../../themes/theme'
import { nonAcceptedFoiStatuses } from '../../util/foiConsts'
import { FOI_RESPONSE_TAB_QUERY_VALUES } from '../../util/consts'
import { config } from '../../config'

const FOINavBar = styled(Tabs)`
  .MuiTabs-flexContainer {
    justify-content: space-between;
  }

  .MuiTabs-indicator {
    display: none;
  }

  .MuiTabs-list {
    flex-wrap: wrap;
  }
`

const FOINavTab = styled(Tab)`
  text-transform: none;
  font-weight: 500;
  font-size: 16px;
  font-family: inherit;
  color: ${theme.colors.text.body};
  text-decoration: ${props => (props.active === 'true' ? 'underline' : 'none')};
  text-underline-offset: 8px;
  text-decoration-thickness: 2px;

  &.Mui-selected {
    color: ${theme.colors.primary};
  }

  &:hover {
    color: ${theme.colors.primary};
  }

  &.Mui-disabled {
    color: ${theme.colors.text.disabled};
    opacity: 0.5;
  }
`

const LOCKED_PRE_ACCEPTANCE_TABS = [
  FOI_RESPONSE_TAB_QUERY_VALUES.letters,
  FOI_RESPONSE_TAB_QUERY_VALUES.deduplicationAndRedaction,
  FOI_RESPONSE_TAB_QUERY_VALUES.documentsAndResponse
]

export function isFoiResponseTabDisabled(tabValue, foiStatus) {
  if (!nonAcceptedFoiStatuses.includes(foiStatus)) return false
  if (tabValue === FOI_RESPONSE_TAB_QUERY_VALUES.billing) return !config.foi.APPLICATION_FEE
  return LOCKED_PRE_ACCEPTANCE_TABS.includes(tabValue)
}

function FOINavigationBar({ activeTab, onChange = () => {}, foiStatus }) {
  const tabs = [
    { label: 'Request', value: 'request', disabled: false },
    { label: 'Communications', value: 'communications', disabled: false },
    { label: 'Letters', value: 'letters', disabled: isFoiResponseTabDisabled('letters', foiStatus) },
    { label: 'Billing', value: 'billing', disabled: isFoiResponseTabDisabled('billing', foiStatus) },
    {
      label: 'Deduplication & Redaction',
      value: 'deduplicationAndRedaction',
      disabled: isFoiResponseTabDisabled('deduplicationAndRedaction', foiStatus)
    },
    {
      label: 'Documents & Response',
      value: 'documentsAndResponse',
      disabled: isFoiResponseTabDisabled('documentsAndResponse', foiStatus)
    }
  ]

  return (
    <FOINavBar value={activeTab} onChange={(_, newValue) => onChange(newValue)}>
      {tabs.map((tab, index) => (
        <FOINavTab
          key={index}
          label={tab.label}
          value={tab.value}
          active={(activeTab === tab.value).toString()}
          disabled={tab.disabled}
          // Prevent stale ripples when search results change the layout.
          disableRipple
        />
      ))}
    </FOINavBar>
  )
}

FOINavigationBar.propTypes = {
  activeTab: PropTypes.oneOf(['request', 'letters', 'deduplicationAndRedaction', 'billing', 'documentsAndResponse', 'communications']).isRequired,
  onChange: PropTypes.func,
  foiStatus: PropTypes.string
}

export default FOINavigationBar
